import { useAuthSession } from "~/shared/hooks/auth.session.admin";
import { ConnectProto } from "@racoon/api";
import { useChildrenOrganizationListQuery } from "./organization.grpc";

/** One empty list for every render, so callers can memoize on it. */
const NO_ORGS: ConnectProto.Organization[] = [];

/**
 * Child orgs of the org being viewed. The RPC lists the caller's own children only
 * (go-backend#454), so viewing any other org gets none rather than the wrong org's.
 */
export function useActiveChildOrgs() {
  const { user, activeCompanyId } = useAuthSession();
  const own = activeCompanyId != null && user?.ownerOrganizationId === activeCompanyId;
  const { data, isLoading } = useChildrenOrganizationListQuery({}, { skip: !own });
  return {
    children: own ? (data?.organizations ?? NO_ORGS) : NO_ORGS,
    isLoading: own && isLoading,
  };
}
